
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";
import { requiredIf } from "vuelidate/lib/validators";
import { ADDRESS_LOOKUP, emptyAddress } from "@/store/addressLookup";
import { IAddressLookupResponse } from "@/store/addressLookup/types";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {
      emptyAddress
    };
  },
  watch: {
    "$v.$invalid": "setValidity"
  },
  computed: {
    physicalAddressLookupResponse(): IAddressLookupResponse {
      return this.$store.state.addressLookup.responses.physical as any;
    },
    physicalAddressLookupInProgress(): boolean {
      return this.$store.state.addressLookup.progress.physical.inProgress;
    },
    physicalAddress: {
      get(): any {
        const physicalAddress =
          store.state.application.applicationData &&
          store.state.application.applicationData.businessDetails &&
          store.state.application.applicationData.businessDetails
            .physicalAddress;

        if (physicalAddress && physicalAddress.fullAddress) {
          return physicalAddress;
        }
        return this.physicalAddressText || emptyAddress;
      },
      set(value: string) {
        // if the value is a string it's a manual address
        const isManualAddress = typeof value === "string";
        const newValue = isManualAddress ? emptyAddress : value;
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_PHYSICAL_ADDRESS),
          newValue
        );

        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_PHYSICAL_ADDRESS),
          isManualAddress
        );
      }
    },
    physicalAddressText: {
      get(): string {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.businessDetails &&
            store.state.application.applicationData.businessDetails
              .physicalAddressText) ||
          ""
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_PHYSICAL_ADDRESS_TEXT),
          value
        );
      }
    },
    hasManualPhysicalAddress: {
      get(): boolean {
        return (
          (store.state.application.applicationData &&
            store.state.application.applicationData.businessDetails &&
            store.state.application.applicationData.businessDetails
              .hasManualPhysicalAddress) ||
          false
        );
      },
      set(value: boolean) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_PHYSICAL_ADDRESS),
          value
        );
      }
    },
    NZBNANZSICCode() {
      const applicationData = store.state.application.applicationData;
      const business =
        applicationData &&
        applicationData.businessDetails &&
        applicationData.businessDetails.business;

      const industryClassification: any =
        business && Array.isArray(business.industryClassification)
          ? business.industryClassification
          : [];

      return industryClassification
        .map((i: any) => {
          // AO-164: ANZSIC code: the four digit number which are characters 2 - 5 of
          // the business industry code. E.g. if the business industry code (aka BIC code)
          // is G412940 then the ANZSIC code is 4129
          return typeof i.classificationCode === "string"
            ? i.classificationCode.substr(1, 4)
            : "";
        })
        .join(",");
    },
    ...mapState({
      businessType: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessType,
      businessName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.businessName,
      tradingName: (state: IApplicationState) =>
        (state.applicationData &&
          state.applicationData.businessDetails &&
          state.applicationData.businessDetails.tradingName) ||
        (state.applicationData &&
          state.applicationData.businessDetails &&
          state.applicationData.businessDetails.businessName),
      NZBNID: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.business &&
        state.applicationData.businessDetails.business.nzbn,

      NZBNRegisterUniqueNumber: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.business &&
        state.applicationData.businessDetails.business
          .sourceRegisterUniqueIdentifier,
      NZBNEntityType: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.businessDetails &&
        state.applicationData.businessDetails.business &&
        state.applicationData.businessDetails.business.entityTypeCode
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {
    setValidity() {
      this.$emit("isvalid", "business", !(this as any).$v.$invalid);
    },
    onPhysicalAddressSearch(address: string) {
      this.$store.dispatch(
        ADDRESS_LOOKUP.NS(ADDRESS_LOOKUP.ACTIONS.ADDRESS_LOOKUP_BY_KEY),
        {
          key: "physical",
          address
        }
      );
    },
    onChangePhysicalAddressText(value: string) {
      if (value) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_PHYSICAL_ADDRESS_TEXT),
          value
        );
      }
    },
    onChangeHasManualPhysicalAddress() {
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_HAS_MANUAL_PHYSICAL_ADDRESS),
        true
      );

      // reset the delivery address object to blank state
      // TODO: figure out that this should actually do
      this.$store.commit(
        APPLICATION.NS(APPLICATION.MUTATIONS.SET_PHYSICAL_ADDRESS),
        emptyAddress
      );
    }
  },
  validations: {
    physicalAddressText: {
      required: requiredIf(vm => vm.hasManualPhysicalAddress && vm.isEditable)
    }
  }
});
